import { jsx, Fragment } from "react/jsx-runtime";
import "../../../Button/Button.js";
import "../../../InputControl/InputControl.js";
import "../../../InputControl/Input/InputBase.js";
import "../../../PhoneInputControl/PhoneInputControl.js";
import "../../../PhoneInputControl/PhoneInput/PhoneInput.js";
import "../../../IconButton/IconButton.js";
import "react";
import "../../../common/ControlBody.js";
import "@mui/material";
import "../context/SelectContext.js";
import "../../../Dialog/Dialog.js";
import "../../../IconButtonNew/IconButton.js";
import "../../../../icons/24/Action/Close.js";
import "../../../../icons/24/Arrow/ChevronLeft.js";
import "./SelectInput/SelectInput.js";
import { DATA_TEST_ID_INHERITED } from "../../../../constants/DATA_TEST_ID_INHERITED.js";
import "../MultiSelect/context/MultiSelectContext.js";
import "../../../../icons/24/System/Check.js";
import "../../../../icons/24/Arrow/ChevronDown.js";
import "../../../TextareaControl/TextareaControl.js";
import { SearchControl } from "../../../SearchControl/SearchControl.js";
import "../../../../icons/24/System/Search.js";
import "../../../FormattedPhone/FormattedPhoneNumber.js";
import "../../../Avatar/styles.js";
import "../../../CheckboxGroup/Checkbox/styles.js";
import "../../../CheckboxGroup/styles.js";
import "../../../RadioGroup/Radio/styles.js";
import "../../../RadioGroup/styles.js";
import "../../../RatingButton/styles.js";
import "../../../FloatingActionButton/styles.js";
import "../../../SortingButton/styles.js";
import "../../../SquareButton/styles.js";
import "../../../Toggle/styles.js";
import "../../../Dialog/StyledDialog.js";
import "../../../Chips/Chip/styles.js";
import "../../../ResultMarksNumber/styles.js";
import "../../../Progress/ProgressCircle/styles.js";
import "../../../Loaders/LoaderCircle/styles.js";
import "../../../Loaders/LoaderLine/styles.js";
import "../../../SegmentedControl/styles.js";
import "../../../ResultMarksText/styles.js";
import "../../../Link/styles.js";
import "../../../Tag/Tag.js";
import "../../../DatePicker/constants.js";
import "../../../DatePicker/components/RangePicker/context/DateRangePickerContext.js";
import "../../../DatePicker/components/RangePicker/context/DateRangePickerContextActions.js";
import "../../../DatePicker/shared/fragments/CalendarCell/CalendarCell.js";
import "../../../../external/classnames/index.js";
import "../../../Scrollbar/Scrollbar.js";
import "../../../DatePicker/shared/fragments/MonthYearSelector/YearSelector.js";
import "../../../DatePicker/components/DatePicker/context/DatePickerContext.js";
import "../../../DatePicker/components/DatePicker/context/DatePickerContextActions.js";
import "../../../MobileBottomSheet/MobileBottomSheet.js";
import "../../../List/ListItem/ListItem.js";
import "../../../Nowrap.js";
import "../../../List/ListItemTree/TreeListItem.js";
import "../../../List/ListItemTree/components/Label.js";
const Search = ({ onSearch, mobileView, ...props }) => /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
  SearchControl,
  {
    "data-test-id": DATA_TEST_ID_INHERITED,
    delay: 200,
    onChange: (e) => onSearch == null ? void 0 : onSearch(e.target.value),
    sx: mobileView ? {} : styles.search,
    placeholder: "Search",
    ...props
  }
) }), MUI_INPUT_BASE_INCREASED_SPECIFICITY_SELECTOR = ".MuiInputBase-root.MuiInputBase-root.MuiInputBase-root", styles = {
  search: {
    [`${MUI_INPUT_BASE_INCREASED_SPECIFICITY_SELECTOR}:after, ${MUI_INPUT_BASE_INCREASED_SPECIFICITY_SELECTOR}:focus-within:after, ${MUI_INPUT_BASE_INCREASED_SPECIFICITY_SELECTOR}.Mui-focused:after`]: {
      content: '""',
      border: "none!important"
    }
  }
};
export {
  Search
};
//# sourceMappingURL=Search.js.map
